

if (Singleton==null)
{
var Singleton = (function () {
var instance;

function createInstance() {
    var object = new Object("I am the instance 22");
    return object;
}

return {
    getInstance: function () {
        if (!instance) {
            instance = createInstance();
        }
     //   console.log(instance);
        return instance;
    }
};
})();
}

if(window.top.Singleton==null)
{


window.top.Singleton=Singleton;
}
